/* eslint-disable react/prop-types */
import React, { useState, memo } from 'react';
import { compose } from 'redux';
import classNames from 'classnames';
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import { isPresent } from 'utils/isPresent';
import Task from './Task';

const styles = (theme) => ({
  header: {
    padding: 15,
  },
  headerToday: {
    color: theme.palette.primary.main,
  },
  headerPastDue: {
    color: theme.palette.error.main,
  },
});

const TaskContent = ({ classes, tasks, header }) => {
  const [page, setPage] = useState(1);
  const increment = () => setPage((prevPage) => prevPage + 1);
  const taskPerPage = 50;
  const lowerIndex = 0;
  const upperIndex = page * taskPerPage;
  const hasMoreTasksToRender = upperIndex < tasks.length;
  // watch out for header.replaceAll() method since some users have a really old browser version
  const headerTestId = header.replace(/\s+/g, '-').toLowerCase();

  if (!isPresent(tasks)) return null;

  let headerColorClass = null;

  if (header === 'Past due') {
    headerColorClass = classes.headerPastDue;
  } else if (header === 'Today') {
    headerColorClass = classes.headerToday;
  }

  return (
    <div data-testid={`${headerTestId}-tasks-container`}>
      {isPresent(header) && (
        <Typography variant="subtitle1" className={classNames(classes.header, headerColorClass)}>
          {header}
        </Typography>
      )}

      {tasks.slice(lowerIndex, upperIndex).map((task) => (
        <Task key={task.id} task={task} />
      ))}
      {hasMoreTasksToRender
        && (
        <Grid
          container
        >
          <Grid item xs={4} />
          <Grid item xs={3}>
            <Button
              color="secondary"
              onClick={increment}
              disabled={!hasMoreTasksToRender}
            >
              Load More
            </Button>
          </Grid>
        </Grid>
        )}
    </div>
  );
};

export default compose(withStyles(styles), memo)(TaskContent);
